import * as yup from 'yup'

const validationSchema = yup.object().shape({
  cpf: yup.string().cpf().required()
})

export default validationSchema
